export default __webpack_public_path__ + "static/media/6.9f89c550.png";